<script>
  import { fade } from "svelte/transition";
  import { asteroid } from "@/meteor";
  import { version } from "@/version";
  import exitIcon from "@iconscout/unicons/svg/exit.svg";
  import usersIcon from "@iconscout/unicons/svg/users-alt.svg";
  import users2Icon from "@iconscout/unicons/svg/user-hard-hat.svg";
  import notesIcon from "@iconscout/unicons/svg/notes.svg";
  import cubeIcon from "@iconscout/unicons/svg/cube.svg";
  import notebooksIcon from "@iconscout/unicons/svg/notebooks.svg";
  import cogIcon from "@iconscout/unicons/svg/cog.svg";
  export let user, url, currentOrder, installPrompt, route;
  let hide = localStorage.getItem("hideNav") === "true";
  let hideOnMobile = true;

  const links = [
    { url: "/orders", name: "Ordrer", icon: notesIcon },
    { url: "/products", name: "Produkter", icon: cubeIcon },
    { url: "/customers", name: "Kunder", icon: usersIcon }
  ];
  const adminLinks = [
    { url: "/users", name: "Brugere", icon: users2Icon },
    { url: "/logs", name: "Log", icon: notebooksIcon },
    { url: "/system", name: "System", icon: cogIcon }
  ];

  $: email = ($user && $user.emails[0].address) || "";
  function signout() {
    hide = true;
    asteroid.logout();
    user.set(false);
  }
  $: (hide || !hide) && localStorage.setItem("hideNav", hide);

  function isActive(url, route) {
    return route.url.startsWith(url);
  }

  addEventListener("pushstate", () => {
    hideOnMobile = true;
  });
</script>

<style>
  .nav-bar {
    @apply fixed top-0 left-0 bottom-0 w-64 bg-white shadow;
    transition: all 0.3s;
  }
  .content {
    transition: all 0.3s;
  }

  .hide {
    /* @apply -ml-64; */
  }
  .burger {
    @apply absolute right-0 top-0 mt-3 cursor-pointer;
    transition: all 0.3s;
  }

  .active {
    @apply bg-gray-200;
  }

  .left-pad {
    @apply pl-4;
  }
  @media (min-width: 768px) {
    .left-pad {
      @apply pl-8;
    }
  }
</style>

<main class="content fixed inset-0 {!hide? "md:ml-64" : ""}">
  <slot>
    <!-- optional fallback -->
  </slot>
</main>
<div>
  {#if !hideOnMobile && $user}
    <div
      class="backdrop md:hidden"
      on:click={() => (hideOnMobile = true)}
      in:fade
      out:fade />
  {/if}
  <div
    class="nav-bar {hide ? 'md:-ml-64' : 'md:ml-0'}
    {hideOnMobile ? '-ml-64' : 'ml-0'}">

    <main class="flex flex-wrap flex-row content-between h-full">
      <div class="w-full left-pad">

        <div class="pt-4 mr-8">
          <a href="/">
            <h3 class="text-2xl font-bold text-orange-500">
              Typographic
              <br />
              Lagerstyring
            </h3>
          </a>
          <div class="text-gray-600 text-xs">v{version}</div>
        </div>
        <!-- Mobile -->
        <div
          class="burger md:hidden {hideOnMobile ? '-mr-8' : 'mr-4'}"
          on:click={() => (hideOnMobile = !hideOnMobile)}>
          ☰
        </div>
        <!-- Desktop -->
        <div
          class="burger hidden md:block {hide ? 'md:-mr-8' : 'md:mr-4'}"
          on:click={() => (hide = !hide)}>
          ☰
        </div>

      </div>

      <div class="left-pad">
        {#if currentOrder && currentOrder._id}
          <div class="text-gray-600 font-semibold uppercase border-b pb-1 mb-2">
            Aktiv ordre
          </div>
          <div class="text-sm">
            <a href={url('orders/id', { id: currentOrder._id })}>
              <strong>{currentOrder.customerName || ''}</strong>

              <small class="italic text-xs text-gray-600">
                {currentOrder._id}
              </small>

              <br />

              {#if currentOrder.items && currentOrder.items.length}
                <div class="text-gray-700">
                  <div>{currentOrder.items[0].productName}</div>
                  {#if currentOrder.items.length > 1}
                    og {currentOrder.items.length > 2 ? currentOrder.items.length + ' andre emner' : 'et andet emne'}
                  {/if}
                </div>
              {/if}
            </a>
          </div>
        {/if}
      </div>

      <!-- Navigation links -->
      <div class="w-full text-gray-900 ">
        <div class="text-xl">
          {#each links as link}
            <a href={link.url}
              class:active={isActive(link.url, route)}
              class="py-1 hover:bg-gray-100 left-pad block">
              <span class="icon-sm">
                {@html link.icon}
              </span>
              <span class="align-middle pl-1" >{link.name}</span>
            </a>
          {/each}
        </div>
        <br />
        <hr />
        <br />

        <div class="text-base">
          {#each adminLinks as link}
            <a href={link.url}
              class:active={isActive(link.url, route)}
              class="py-1 hover:bg-gray-100 left-pad block">
              <span class="icon-xs">
                {@html link.icon}
              </span>
              <span class="align-middle pl-1" >{link.name}</span>
            </a>
          {/each}
        </div>
      </div>

      <div class="w-full" />
      <div class="w-full" />
      <div class="w-full" />

      <div class="w-full left-pad">
        <div class="mb-4">
          <div class="text-gray-700 w-48 truncate">{email}</div>
          <button on:click={signout} class="text-gray-800">
            <span class="icon-xs">
              {@html exitIcon}
            </span>
            <span class="align-middle">Log af</span>
          </button>
        </div>

        {#if installPrompt}
          <button
            class="mb-4 btn sm outline gray"
            on:click={() => installPrompt.prompt()}>
            Installér app
          </button>
        {/if}
      </div>
    </main>
  </div>
</div>
